import { useState } from "react";
import { Checkbox } from "@mui/material";
import { ThemeInput } from "components/components";
import { Button, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";

const Facebook = () => {
  const [showFields, setShowFields] = useState(false);
  const onChange = (e) => {
    setShowFields(e.target.checked);
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(
      "https://demo-saas.worksuite.biz/paypal-webhook/3a835e0ccbbd218f87c62a440878d64d"
    );
    message.success("Webhook URL Copied!");
  };
  return (
    <div className="bg-themeGray-light200 p-3 -mt-4 -ml-2 min-h-[70vh] desktop:h-[76vh] bigDesktop:h-[83vh]">
      <div className="bg-white p-3 shadow-md">
        <div className="flex items-center">
          <Checkbox onChange={onChange} />
          <p>Status</p>
        </div>
        {showFields && (
          <div>
            <ThemeInput placeholder={"Facebook App ID"} />
            <ThemeInput placeholder={"Facebook Secret"} password />
            <div className="mt-3">
              <p className="opacity-90 pb-1">Callback</p>
              <p>https://demo-saas.worksuite.biz/callback/facebook</p>
              <Button
                onClick={copyToClipboard}
                className="flex items-center opacity-80 h-9 mt-2"
              >
                <FontAwesomeIcon icon={faCopy} />
                <p className="ml-2">Copy</p>
              </Button>
              <p className="mt-3 text-red-500">
                (Add this callback url on your facebook app settings.)
              </p>
              <Button
                type="primary"
                className="mt-2 w-full"
                onClick={() => message.success("Successfully saved settings")}
              >
                Save
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Facebook;
